import { uuid } from '../../uuid'
let { defaultState } = require('./state.js')

export default {
    reset: (state) => {
        Object.assign(state, defaultState())
    },
    start(state) {
        state.start = new Date().toISOString()
        state.uuid = uuid()
        state.patient_uuid = `ThinkMD-${uuid()}`
    },
    resume(state, payload) {
        Object.assign(state, payload)
    }
}
